import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { NvDesignLibraryModule } from '../../../../../nvps-libraries/design/nv-design-library.module';
import { BaseModalModule } from '../../base-modal.module';
import { SyncedSheetColumnsModalComponent } from './synced-sheet-columns-modal.component';

@NgModule({
  declarations: [SyncedSheetColumnsModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    FormsModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    BaseModalModule,
    NvDesignLibraryModule,
  ],
  exports: [SyncedSheetColumnsModalComponent],
  providers: [],
  entryComponents: [SyncedSheetColumnsModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SyncedSheetColumnsModule {}
